import { render } from "./ShopLocal.vue?vue&type=template&id=58626910&scoped=true"
import script from "./ShopLocal.vue?vue&type=script&lang=js"
export * from "./ShopLocal.vue?vue&type=script&lang=js"

import "./ShopLocal.vue?vue&type=style&index=0&id=58626910&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58626910"]])

export default __exports__